/** @format */
import { useTranslation } from 'next-i18next';

import { SearchFacet } from '@toucan/common/services/search/constants';

export function useTranslatedFacetTitles() {
    const { t } = useTranslation();

    const options = {
        context: 'searchFacet',
    };

    return {
        [SearchFacet.modelCategory]: t('Category', options),
        [SearchFacet.modelBrand]: t('Brand', options),
        [SearchFacet.modelProductType]: t('Product type', options),
        [SearchFacet.productPrice]: t('Price', options),
        [SearchFacet.productPriceModifier]: t('Accessories', options),
        [SearchFacet.productConditionStarRating]: t(
            'Cosmetic condition',
            options
        ),
        [SearchFacet.modelSystem]: t('System', options),
        [SearchFacet.modelAaBatteryCompatableModelSpecificationBool]: t(
            'AA battery compatible',
            options
        ),
        [SearchFacet.modelAutoFocusPointsModelSpecificationNum]: t(
            'Autofocus points',
            options
        ),
        [SearchFacet.modelBuiltInFlashModelSpecificationBool]: t(
            'Built-in flash',
            options
        ),
        [SearchFacet.modelBuiltInWifiModelSpecificationBool]: t(
            'Built-in wifi',
            options
        ),
        [SearchFacet.modelBulitInMicrophoneModelSpecificationBool]: t(
            'Built-in microphone',
            options
        ),
        [SearchFacet.modelCameraMountModelSpecificationPhrase]: t(
            'Camera mount',
            options
        ),
        [SearchFacet.modelFilterThreadMmModelSpecificationNum]: t(
            'Filter thread (mm)',
            options
        ),
        [SearchFacet.modelHeadphoneJackModelSpecificationBool]: t(
            'Headphone jack',
            options
        ),
        [SearchFacet.modelLensMountModelSpecificationPhrase]: t(
            'Lens mount',
            options
        ),
        [SearchFacet.modelMaximumApertureTeleFModelSpecificationNum]: t(
            'Maximum aperture tele F',
            options
        ),
        [SearchFacet.modelMaximumApertureWideFModelSpecificationNum]: t(
            'Maximum aperture wide F',
            options
        ),
        [SearchFacet.modelMaximumFramesPerSecondModelSpecificationNum]: t(
            'Maximum frames per second',
            options
        ),
        [SearchFacet.modelMaximumIsoModelSpecificationNum]: t(
            'Maximum ISO',
            options
        ),
        [SearchFacet.modelMaximumVideoResolutionModelSpecificationPhrase]: t(
            'Maximum video resolution',
            options
        ),
        [SearchFacet.modelMegapixelsModelSpecificationNum]: t(
            'Megapixels',
            options
        ),
        [SearchFacet.modelMicrophoneJackModelSpecificationPhrase]: t(
            'Microphone jack',
            options
        ),
        [SearchFacet.modelMinimumFocusDistanceMModelSpecificationNum]: t(
            'Minimum focus distance',
            options
        ),
        [SearchFacet.modelSensorFormatModelSpecificationPhrase]: t(
            'Sensor format',
            options
        ),
        [SearchFacet.modelStorageMediaTypeModelSpecificationPhrase]: t(
            'Storage media type',
            options
        ),
        [SearchFacet.modelTouchscreenModelSpecificationBool]: t(
            'Touchscreen',
            options
        ),
        [SearchFacet.modelUsbPortTypeModelSpecificationPhrase]: t(
            'USB port type',
            options
        ),
        [SearchFacet.modelViewfinderTypeModelSpecificationPhrase]: t(
            'Viewfinder',
            options
        ),
        [SearchFacet.modelWeightGramsModelSpecificationNum]: t(
            'Weight (grams)',
            options
        ),
        [SearchFacet.modelMinimumIsoModelSpecificationNum]: t(
            'Minimum ISO',
            options
        ),
        [SearchFacet.modelMinimumShutterSpeedXSecondsModelSpecificationNum]: t(
            'Minimum shutter speed',
            options
        ),
        [SearchFacet.modelMaximumVideoFrameRateFpsModelSpecificationNum]: t(
            'Maximum video framerate',
            options
        ),
        [SearchFacet.modelYearOfReleaseModelSpecificationNum]: t(
            'Year of release',
            options
        ),
        [SearchFacet.modelApertureBladesModelSpecificationNum]: t(
            'Aperture blade count',
            options
        ),
        [SearchFacet.modelArticulatingLcdScreenModelSpecificationBool]: t(
            'Articulating LCD screen',
            options
        ),
        [SearchFacet.modelAutoFocusModelSpecificationBool]: t(
            'Auto focus',
            options
        ),
        [SearchFacet.modelBuiltInBluetoothModelSpecificationBool]: t(
            'Built-in bluetooth',
            options
        ),
        [SearchFacet.modelBuiltInLensHoodModelSpecificationBool]: t(
            'Build-in lens hood',
            options
        ),
        [SearchFacet.modelCameraTypeModelSpecificationPhrase]: t(
            'Camera type',
            options
        ),
        [SearchFacet.modelDropInFilterDiameterModelSpecificationNum]: t(
            'Drop-in filter diameter',
            options
        ),
        [SearchFacet.modelFileFormatModelSpecificationPhrase]: t(
            'File format',
            options
        ),
        [SearchFacet.modelFlashCompatibilityModelSpecificationPhrase]: t(
            'Flash compatability',
            options
        ),
        [SearchFacet.modelHotShoeConnectionModelSpecificationBool]: t(
            'Hot shoe connection',
            options
        ),
        [SearchFacet.modelImageStabilizationModelSpecificationBool]: t(
            'Image stabalization',
            options
        ),
        [SearchFacet.modelIntegratedCleaningModelSpecificationBool]: t(
            'Integrated cleaning',
            options
        ),
        [SearchFacet.modelLcdResolutionPixelsModelSpecificationNum]: t(
            'LCD resolution (pixels)',
            options
        ),
        [SearchFacet.modelLcdSizeInchesModelSpecificationNum]: t(
            'LCD size (inches)',
            options
        ),
        [SearchFacet.modelLiveViewModelSpecificationBool]: t(
            'Live view',
            options
        ),
        [SearchFacet.modelMaximumShutterSpeed1SecondsModelSpecificationPhrase]:
            t('Maximum shutter speed (seconds)', options),
        [SearchFacet.modelMinimumApertureFModelSpecificationNum]: t(
            'Minimum aperture',
            options
        ),
        [SearchFacet.modelOpticalZoomXModelSpecificationNum]: t(
            'Optical zoom',
            options
        ),
        [SearchFacet.modelSensorTypeModelSpecificationPhrase]: t(
            'Sensor type',
            options
        ),
        [SearchFacet.modelShutterRatingLifeModelSpecificationNum]: t(
            'Shutter rating',
            options
        ),
        [SearchFacet.modelViewfinderCoverageModelSpecificationNum]: t(
            'Viewfinder coverage',
            options
        ),
    };
}
